export interface RangeItem {
  low: number;
  high: number;
  checkOutsideRange: boolean; // Should default to false || Subject to discussion.
  index: number;
  color: string | null;
  name: string | null;
}

export class RangeItemClass implements RangeItem {
  low: number;
  high: number;
  checkOutsideRange: boolean;
  index: number;
  color: string | null;
  name: string | null;

  constructor(o: any = {}) {
    this.low = o['low'] ?? null;
    this.high = o['high'] ?? null;
    this.checkOutsideRange = o['checkOutsideRange'] ?? null;
    this.index = o['index'] ?? null;
    this.color = o['color'] ?? null;
    this.name = o['name'] ?? null;
  }
}

export interface RangeItemList {
  items: RangeItem[];
  name: string | null;
}

export class RangeItemListClass implements RangeItemList {
  items: RangeItem[];
  name: string | null;

  constructor(o: any = {}) {
    this.items = o['items']
      ? Array.from(o['items']).map((item: any) => new RangeItemClass(item))
      : [];
    this.name = o['name'] ?? null;
  }
}
